import type { BugTrendUnit } from '../../../types/api.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 信頼性ページのチャート X 軸目盛りフォーマッタ。週次（週開始日 YYYY-MM-DD）は桁が多いため MM-DD に短縮しつつ、年跨ぎで年の区別が消えないよう各年最初の週（1/1〜1/7 開始）だけ YY-MM-DD で年を残す。月次はそのまま返す（ツールチップは常に全体表示）
 * @graph-connects none
 */
export function formatPeriodTick(value: string, unit: BugTrendUnit): string {
  // 週開始日 YYYY-MM-DD（10桁）以外はそのまま返す
  if (unit !== 'week' || value.length !== 10) return value;
  const month = value.slice(5, 7);
  const day = Number(value.slice(8, 10));
  // 年の最初の週だけ YY-MM-DD で年を残す
  // （months=24 等の年跨ぎ表示で 12-28 と 01-04 が同年に見えるのを防ぐ）
  if (month === '01' && day <= 7) return value.slice(2);
  return value.slice(5);
}
